import { Injectable } from '@angular/core';
import * as braze from '@braze/web-sdk';
import { co } from '@fullcalendar/core/internal-common';

@Injectable({
  providedIn: 'root',
})
export class BrazeService {
  jobOnlySchool: boolean = false;
  isSubscriptionExpired: boolean = false;
  isPremiumSubscription: boolean = false;
  currentPlan: any;

  initializeBraze(data: any): void {
    const props = data?.properties || {};
    const user = data?.mixpanel_data || {};

    braze.initialize(props.braze_sdk_api_key, {
      baseUrl: 'https://sdk.au-01.braze.com',
      enableLogging: false,
      allowUserSuppliedJavascript: true,
    });

    this.jobOnlySchool = props.job_only_school || false;
    this.isSubscriptionExpired = user.is_subscription_expired || false;
    this.isPremiumSubscription = user.is_premium_subscription || false;
    this.currentPlan = user.current_plan || '';

    braze.changeUser(user.user_id);
    const brazeUser = braze.getUser();
    if (!brazeUser) return;

    brazeUser.setEmail(user.email);
    // console.log('Braze user email set to:', user.email);
    brazeUser.setFirstName(user.first_name);
    brazeUser.setLastName(user.last_name);

    if (this.jobOnlySchool) {
      brazeUser.setCustomUserAttribute('subscription_type', user.subscription_type);
      let jobSubscription = '';
      if (this.isPremiumSubscription && !this.isSubscriptionExpired) {
        jobSubscription = 'Premium';
      } else if (!this.isPremiumSubscription && !this.isSubscriptionExpired && this.currentPlan) {
        jobSubscription = 'Starter';
      }
      brazeUser.setCustomUserAttribute('job_subscription', jobSubscription);
    }
    brazeUser.setCustomUserAttribute('is_qld_doe_relief_teacher', props.is_qld_doe_relief_teacher ?? props.is_qld_teacher);
    brazeUser.setCustomUserAttribute('is_qld_doe_school_user', props.is_qld_school);
    brazeUser.setCustomUserAttribute('qld_doe_user', props.is_qld_user);
    brazeUser.setCustomUserAttribute('User_type', user.user_type);
    if (user.user_type === 'school') {
      brazeUser.setCustomUserAttribute('Group_name', user.group_name);
    }
    braze.openSession();
    braze.automaticallyShowInAppMessages();
  }
}
